import React from 'react';
import PropTypes from 'prop-types';

const MSG = {
  isRequired: 'Full name is required',
  matches: 'Last name is required',
};

export default function FullName({
  Field, Err, useInput, errors, focus,
}) {
  const fieldRef = React.useRef();

  React.useEffect(() => {
    fieldRef.current[focus ? 'focus' : 'blur']();
  }, [focus]);

  return (
    <React.Fragment>
      <Field
        ref={fieldRef}
        type="text"
        placeholder="full name"
        {...useInput('fullName', {
          isRequired: true,
          matches: /[^\s]\s+[^\s]/,
        })}
      />
      {!!errors.fullName && <Err>{MSG[errors.fullName]}</Err>}
    </React.Fragment>
  );
}

FullName.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    fullName: PropTypes.string,
  }),
  focus: PropTypes.bool,
};

FullName.defaultProps = {
  errors: { fullName: null },
  focus: false,
};
